import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";

export default function BasicSelect({ roles, onChange, value }) {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Role*</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          sx={{ width: "100%", height: "2.8rem" }}
          label="Age"
          onChange={handleChange}
        >
          {roles.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.displayText}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

BasicSelect.propTypes = {
  roles: PropTypes.any,
  onChange: PropTypes.any,
  value: PropTypes.any,
};
